import React, { useState, useEffect, useRef } from 'react';

import { Row, Col } from "reactstrap";

import ControldocDataTable from "../../../controldoc/datatable";

const BulkNotificationSignSignerList = props => {
  const [selectedSigners, setSelectedSigners] = useState([]);

  const {
    dataTableConfiguration: {
      columns: dataTableColumns
    },
    configuration: {
      context,
      defaultRequestParams,
      formName,
      showDistributionListFilter,
    },
    routes: {
      indexSignersPath
    }
  } = props;

  const onSelectionChange = selectedRecords => {
    setSelectedSigners(selectedRecords);
  }

  const drawSelectedSignersInput = () => {
    return (
      <>
        {_.map(selectedSigners, function (signer) {
          return (
            <div key={`signer-input-${signer.id}`}>
              <input
                type="hidden"
                name={`${formName}[items_attributes][][signer_id]`}
                value={signer.id}
              />
            </div>
          );
        })}
      </>
    );
  };

  return(
    <Row>
      <Col md="12">
        <ControldocDataTable
          columns={ dataTableColumns }
          configuration={{
            showDistributionListFilter: showDistributionListFilter,
            showGridlines: true,
            context: context,
            fetchRecords: {
              endpoint: indexSignersPath,
              keyName: 'signers',
              defaultRequestParams: defaultRequestParams
            },
            selectable: {
              enabled: true,
              mode: 'multiple',
              selection: selectedSigners,
              onSelectionChange: onSelectionChange
            }
          }}
        >
        </ControldocDataTable>
      </Col>
      {drawSelectedSignersInput()}
    </Row>
  )
}

export default BulkNotificationSignSignerList;
